import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'
import reportWebVitals from './reportWebVitals';
import './i18n';

import { RecoilRoot } from 'recoil';

// Dedicated API client with auth interceptors (see Config/apiClient.js).
// The global axios instance is intentionally left WITHOUT interceptors
// so that any requests to third-party domains won't leak the JWT token.
import './Config/apiClient';

// Service Worker: registra in produzione, de-registra + pulisci cache in sviluppo
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(registration => {
        // Forza il controllo degli aggiornamenti del SW
        registration.update();
        console.log('Service Worker registrato con successo:', registration);
      }).catch(error => {
        console.log('Registrazione dello Service Worker fallita:', error);
      });
    });
  } else {
    // In sviluppo: de-registra tutti i SW e pulisci tutte le cache
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(r => r.unregister());
    });
    caches.keys().then(names => {
      names.forEach(name => caches.delete(name));
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  // </React.StrictMode>
);

// Misurazione performance (opzionale)
reportWebVitals();
